export const toHarfWidthAndUpperCase = (str: string) => {
  const harfWidth = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s: string) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
  return harfWidth.toUpperCase();
};
